import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import About from "./sections/About";
import WhyChoose from "./sections/WhyChoose";
import ImportersProblem from "./sections/ImportersProblem";
import ProductCategories from "./sections/ProductCategories";
import Industries from "./sections/Industries";
import Process from "./sections/Process";
import GlobalMarkets from "./sections/GlobalMarkets";
import Testimonials from "./sections/Testimonials";
import FAQ from "./sections/FAQ";
import Contact from "./sections/Contact";
import Footer from "./sections/Footer";
import FloatingWhatsApp from "./sections/FloatingWhatsApp";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import { getToken } from "./lib/api";

function ProtectedAdmin({ children }) {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicSite() {
  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <About />
        <WhyChoose />
        <ImportersProblem />
        <ProductCategories />
        <Industries />
        <Process />
        <GlobalMarkets />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<PublicSite />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <ProtectedAdmin>
              <AdminDashboard />
            </ProtectedAdmin>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
